import React from "react";
import { motion } from "framer-motion";

/* One slow editorial marquee — massive display type, thin dividers, blue asterisks. */
const WORDS = [
  "PPF",
  "Ceramic",
  "Detailing",
  "Paint Correction",
  "Bed Liner",
  "Headlight",
  "Odor",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="relative overflow-hidden py-14 md:py-20 border-y border-white/10 bg-[#0a0a0d]"
      aria-hidden="true"
    >
      <motion.div
        className="flex whitespace-nowrap gap-14 md:gap-24"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 55, repeat: Infinity, ease: "linear" }}
      >
        {[...WORDS, ...WORDS, ...WORDS, ...WORDS].map((w, i) => (
          <div key={i} className="flex items-center gap-14 md:gap-24 shrink-0">
            <span className="font-display font-light text-white/90 text-[64px] md:text-[128px] lg:text-[168px] leading-none tracking-[-0.045em]">
              {w}
            </span>
            <span className="text-[#1F5EFF] font-display text-4xl md:text-6xl select-none">✱</span>
          </div>
        ))}
      </motion.div>
    </section>
  );
}
